var myApp = myApp || {};
var pcBreak = 1239.98;
var spBreak = 767.98;
var isBodyFrozen = false;

myApp.init = function () {
  // Initialize
  myApp.detectDevice();
  myApp.tabletViewport();

  // Module
  myApp.hamburgerMenu();
  myApp.slider();
  myApp.smoothScroll();
  myApp.accordion();
  myApp.listTabs();
  myApp.headerScroll();
};

// Detect devices
myApp.detectDevice = function () {
  var userAgent = navigator.userAgent.toLowerCase();

  // System
  if (userAgent.indexOf("mac os x") != -1) {
    $("html").addClass("is-ios");
  }
  if (userAgent.indexOf("android") > -1) {
    $("html").addClass("is-android");
  }

  //Browser
  if (userAgent.indexOf("chrome") > -1) {
    $("html").addClass("is-chrome");
  }
  if (userAgent.indexOf("trident") > -1) {
    $("html").addClass("is-ie");
  }
  if (userAgent.indexOf("edge") > -1) {
    $("html").removeClass("is-chrome");
    $("html").addClass("is-edge");
  }
  if (userAgent.indexOf("edg/") > -1) {
    $("html").removeClass("is-chrome");
    $("html").addClass("is-chromium");
  }
  if (userAgent.indexOf("firefox") > -1) {
    $("html").addClass("is-firefox");
  }
  if (userAgent.indexOf("safari") > -1 && userAgent.indexOf("chrome") < 0) {
    $("html").addClass("is-safari");
  }
};

// Detect viewport
myApp.tabletViewport = function () {
  var viewport = $("#viewport")[0];
  var viewportSet = function () {
    if (screen.width >= spBreak + 0.02 && screen.width < pcBreak + 0.02) {
      viewport.setAttribute(
        "content",
        "width=" + (pcBreak + 0.02) + ", user-scalable=0"
      );
      $("html").addClass("is-tablet");
    } else {
      viewport.setAttribute(
        "content",
        "width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=0"
      );
      $("html").removeClass("is-tablet");
    }
  };
  viewportSet();
  $(window).on("load resize", function () {
    viewportSet();
  });
};

// Check if it's mobile
myApp.isMobile = function () {
  return window.matchMedia("(max-width: " + spBreak + "px)").matches;
};

// Remove a specific inline CSS
myApp.removeCSSProperty = function (target, property) {
  if (property === null || property === "") {
    $(target).removeAttr("style");
  } else {
    $(target).css(property, "");
  }
};

// Fixed element while scrolling
myApp.fixedScrolling = function (target, type, opposite) {
  var windowWidth = $(window).innerWidth();
  var scrollLeft = $(window).scrollLeft();
  var containerWidth = $(".container").width();
  var offsetLeft = -scrollLeft;
  var offsetRight = -(containerWidth - windowWidth - scrollLeft);
  if (opposite === true) {
    offsetLeft = -offsetLeft;
    offsetRight = -offsetRight;
  }
  if (type === "right") {
    if (windowWidth < pcBreak && myApp.isMobile() !== true) {
      $(target).css("right", offsetRight + "px");
    } else {
      myApp.removeCSSProperty(target, "right");
    }
  } else if (type === "left") {
    if (windowWidth < pcBreak && myApp.isMobile() !== true) {
      $(target).css("left", offsetLeft + "px");
    } else {
      myApp.removeCSSProperty(target, "left");
    }
  } else {
    if (windowWidth < pcBreak && myApp.isMobile() !== true) {
      $(target).css("right", offsetRight + "px");
      $(target).css("left", offsetLeft + "px");
    } else {
      myApp.removeCSSProperty(target, "right");
      myApp.removeCSSProperty(target, "left");
    }
  }
};

// Froze window
myApp.frozeWindow = function (boolean) {
  var scrollTop = 0;
  if (boolean === true) {
    isBodyFrozen = true;
    scrollTop = $(window).scrollTop();
    $("html,body").addClass("is-frozen");
    $(".container").css("top", -scrollTop);
  } else {
    isBodyFrozen = false;
    scrollTop = parseInt($(".container").css("top"), 10);
    $("html,body").removeClass("is-frozen");
    myApp.removeCSSProperty($(".container"), "top");
    $("html,body").scrollTop(-scrollTop);
  }
};

// Menu with Hamburger button
myApp.hamburgerMenu = function () {
  if ($("header").length) {
    var target = $(".js-hamburger-target");
    var button = $(".js-hamburger-button");
    button.on("click", function () {
      if (target.hasClass("is-active")) {
        myApp.frozeWindow(false);
        button.removeClass("is-active");
        target.removeClass("is-active");
      } else {
        myApp.frozeWindow(true);
        button.addClass("is-active");
        target.addClass("is-active");
      }
      return false;
    });
  }
};

// Header when scrolling
myApp.headerScroll = function () {
  if (isBodyFrozen !== true) {
    var scrollTop = $(window).scrollTop();
    var limit = 1;
    if (scrollTop > limit) {
      $("header").addClass("is-passed");
    } else {
      $("header").removeClass("is-passed");
    }
  }
  if ($("header").css("position") === "fixed") {
    myApp.fixedScrolling($("header"), "right", false);
    myApp.fixedScrolling($("header"), "left", false);
    myApp.fixedScrolling($("header .header-navigation"), "right", false);
    myApp.fixedScrolling($("header .header-navigation"), "left", false);
  } else {
    myApp.removeCSSProperty($("header"), "right");
    myApp.removeCSSProperty($("header"), "left");
    myApp.removeCSSProperty($("header .header-navigation"), "right");
    myApp.removeCSSProperty($("header .header-navigation"), "left");
  }
};

$(window).on("load scroll resize", () => {
  myApp.headerScroll();
});

// Slider
myApp.slider = function () {
  if ($(".js-slider-dot").length) {
    $(".js-slider-dot").slick({
      dots: true,
      customPaging: function () {
        return "<div></div>";
      },
      arrows: false,
      autoplay: true,
      infinite: true,
      focusOnSelect: false,
      pauseOnHover: false,
      speed: 300,
      autoplaySpeed: 3000,
      cssEase: "linear",
      slidesToShow: 3,
      centerMode: true,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: spBreak,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  if ($(".js-slider-scroll").length) {
    var slider = $(".js-slider-scroll .slider-wrapper");
    var maxSlidePC = 5;
    var barProgress = $(".js-slider-scroll .slider-bar .bar-progress");
    slider.on("init", function () {
      var max = slider.find(".slick-dots li").length;
      barProgress.css("width", 100 / max + "%");
    });
    slider.slick({
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      focusOnSelect: false,
      pauseOnHover: false,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: maxSlidePC,
      autoplaySpeed: 3000,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: spBreak,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    slider.on("afterChange", function () {
      var max = slider.find(".slick-dots li").length;
      var current = slider.find(".slick-dots .slick-active").index();
      var percent = 100 / max;
      barProgress.css("width", percent + "%");
      barProgress.css("left", current * percent + "%");
    });
  }
  
    if ($(".Ones__productSlider").length) {
    var slider = $(".Ones__productSlider .slider-wrapper");
    var maxSlidePC = 3;
    var barProgress = $(".Ones__productSlider .slider-bar .bar-progress");
    slider.on("init", function () {
      var max = slider.find(".slick-dots li").length;
      barProgress.css("width", 100 / max + "%");
    });
    slider.slick({
      dots: true,
      arrows: false,
      autoplay: false,
      infinite: false,
      focusOnSelect: false,
      pauseOnHover: false,
      speed: 300,
      slidesToScroll: 1,
      slidesToShow: maxSlidePC,
      autoplaySpeed: 3000,
      cssEase: "linear",
      responsive: [
        {
          breakpoint: spBreak,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
    slider.on("afterChange", function () {
      var max = slider.find(".slick-dots li").length;
      var current = slider.find(".slick-dots .slick-active").index();
      var percent = 100 / max;
      barProgress.css("width", percent + "%");
      barProgress.css("left", current * percent + "%");
    });
  }
};

myApp.smoothScroll = function () {
  var anchorElement = $(".js-smooth");
  var anchorPosition = 0;
  var anchorSpeed = 300;
  if (window.location.hash) {
    var replaceHash = window.location.hash.replace("#", "");
    if ($('[data-id="' + replaceHash + '"]').length) {
      anchorPosition =
        $('[data-id="' + replaceHash + '"]').offset().top -
        $("header").outerHeight() -
        15;
    } else {
      anchorPosition = 0;
    }
    setTimeout(function () {
      $("html, body").animate({ scrollTop: anchorPosition }, anchorSpeed);
    }, 800);
  }
  anchorElement.on("click", function () {
    var href = $(this).attr("href").split("#")[1];
    var targetSection = $(href == "" ? "html" : '[data-id="' + href + '"]');
    anchorPosition =
      targetSection.offset().top - $("header").outerHeight() - 15;
    $("html, body").animate(
      { scrollTop: anchorPosition },
      anchorSpeed,
      "swing"
    );
    return false;
  });
};

// Accordion
myApp.accordion = function () {
  if ($(".js-accordion").length) {
    $(".js-accordion").each(function () {
      var parent = $(this);
      parent.find(".js-accordion-toggle").on("click", function () {
        var button = $(this);
        if (parent.hasClass("is-active")) {
          button.removeClass("is-active");
          parent.removeClass("is-active");
          parent.find(".js-accordion-target").slideUp(300);
        } else {
          button.addClass("is-active");
          parent.addClass("is-active");
          parent.find(".js-accordion-target").slideDown(300);
        }
        return false;
      });
    });
  }
};

myApp.listTabs = function () {
  if ($(".js-list-tabs").length) {
    var selector = ".js-list-tabs li",
      selectorContent = ".tab-container";
    var init = function () {
      $(selector).click(function () {
        var tabId = $(this).attr("data-tab");
        $(selector).removeClass("is-current");
        $(selectorContent).removeClass("is-current");
        $(this).addClass("is-current");
        $("#" + tabId).addClass("is-current");
      });
    };
    if ($(selector).length) {
      init();
    }
  }
};

$(function () {
  myApp.init();
});

$(function () {
  AOS.init({
    duration: 2000,
    once: true,
    //useClassNames: true,
    //initClassName: false,
    //animatedClassName: 'animate__animated',
  });
  //app.init();
});

//Slide Toggle--GUIDE page
$(function () {
  $('.js-accordion-title').on('click', function () {
    $(this)
      .next()
      .slideToggle();
    $(this)
      .next()
      .toggleClass('open');
    $(this).toggleClass('open');
  });
  
});

//modal
(function () {
  if ($('.js-modal-video').length) {
    //クラス名js-modal-videoがあれば以下を実行
    $('.js-modal-video').modalVideo({
      channel: 'youtube',
      youtube: {
        rel: 0, //関連動画の指定
        autoplay: 0, //自動再生の指定
        controls: 0 //コントロールさせるかどうかの指定
      }
    });
  }
})();

//ONE-S 商品ページスライダー
$(document).on('ready', function() {
  $(".Ones__productSlider").slick({
    slidesToShow: 3,
  });

});

$(function() {
  $(window).scroll(function() {
    $(".scroll-block").each(function() {
      var scroll = $(window).scrollTop();
      var blockPosition = $(this).offset().top;
      var windowHeihgt = $(window).height();
      if (scroll > blockPosition - windowHeihgt + 300) {
        $(this).addClass("blockIn");
      }
    });
  });
});
